const OperationalDistrictFunction = [
  {
    id: 1,
    gpText: "Street Authority (NRSWA)",
  },
  {
    id: 2,
    gpText: "Highway Authority (works promoter)",
  },
  {
    id: 3,
    gpText: "Utility",
  },
  {
    id: 4,
    gpText: "Private Street Manager",
  },
  {
    id: 5,
    gpText: "Transport Authority",
  },
  {
    id: 6,
    gpText: "Bridge Authority",
  },
  {
    id: 7,
    gpText: "Sewer Authority",
  },
  {
    id: 8,
    gpText: "Street Naming Authority",
  },
  {
    id: 9,
    gpText: "Permit Authority",
  },
];

export default OperationalDistrictFunction;
